import React from 'react';
import { Skeleton } from '@atlassian/jira-common-components-skeleton/src/styled.tsx';

export const FieldLoader = () => <Skeleton width="350px" height="40px" />;
